// @flow
import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ContactContainer from "./ContactContainer";
import ProtectedRoute from "../shared/ProtectedRoute";

const ContactRoute: React.ComponentType<any> = withRouter(
  connect(() => {
    return {
      component: ContactContainer,
      restProps: null,
      isAllowedRoute: true,
      redirectTo: "/",
    };
  })(ProtectedRoute)
);

export default ContactRoute;
